<template>
  <div style="height: 80vh" class="d-flex justify-center align-center">
    <v-progress-circular
      :size="50"
      color="blue"
      indeterminate
    ></v-progress-circular>
  </div>
</template>
<script>
import apifactory from "../api";
import baseapifactory from "../../../apis/apifactory";
export default {
  setup() {},
  data() {
    return {
      counternumber: 100,
      countDown: 0,
      listfind_decay: [],
      listfind_decay_output: [],
      listsavefordb: [],
      listsavefordbfinal: [],
      isdecayalreaysave: 0,
    };
  },
  methods: {

    // step1

     call_api_checkdata() {
      //alert("call_api_checkdata_fordataprepration");
      baseapifactory
        .api_get_project_data_instep1()
        .then((res) => {
          //alert(JSON.stringify(res));
          
          if (res.data.status != 402) {
           this.call_api_checkprojectdataforStep3();
          }
          else{
             alert("Sorry Please set the project .");
              this.$router.push("/settingproject");

          }
        })
        .catch(function (error) {
          alert("call_api_save_step3" + error);
          // return false;
        });
    },
     call_api_checkprojectdataforStep3() {
      //alert("call_api_checkdata_fordataprepration");
      baseapifactory
        .gettheParameterByProjectStep("3")
        .then((res) => {
          //alert(JSON.stringify(res));
          let url_querystring ="  trend=0&season=0&decay=0";
          if (res.status != 200) {
           url_querystring="trend=0&season=0&decay=0";
          } else {
            this.parmStore = res.data;
            url_querystring = "trend="+res.data["trend"]+"&season="+res.data["season"]+"&decay="+res.data["decay"]+"";
          
          }
           //alert(url_querystring);
           this.saveAndSetStepParms(url_querystring);
        })
        .catch(function (error) {
          alert("call_api_checkprojectdataforStep3" + error);
          // return false;
        });
    },
    saveAndSetStepParms(varparms) {
      let url_querystring = varparms;//"trend=0&season=0&decay=0";

      apifactory
        .addParameterBySteps("3", url_querystring)
        .then((res) => {
          ////alert(JSON.stringify(res));
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
           this.callworkflowsteps();
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
    },
      // step2
    callworkflowsteps() {
      this.call_api_save_step3();
    },
     // step3
    call_api_save_step3() {
      baseapifactory
        .api_save_step3()
        .then((res) => {
          ////alert(JSON.stringify(res));
          if (res != null) {
            this.callapi_save_find_decay();
          }
        })
        .catch(function (error) {
          alert("call_api_save_step3" + error);
          // return false;
        });
    },
  
 // step4
    callapi_save_find_decay() {
     // alert('call-2');
      apifactory
        .call_save_find_decay()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.call_api_call_find_decay();
            //this.$router.push("/sessionalitysetting");
          }
        })
        .catch(function (error) {
          alert('callapi_save_find_decay'+error);
          // return false;
        });
    },
    
    // step5
    call_api_call_find_decay() {
       // alert('call-3');
      apifactory
        .call_find_decay()
        .then((res) => {
          if (res != null) {
            let templist = [];
            templist = res.data.decay_output;
            this.listfind_decay = templist.filter(
              (a) => a.TrigmaAI_Recommendation == "Recommended"
            );
            ////alert(JSON.stringify(this.listfind_decay));
            this.call_api_call_save_channel_decay();
          }
        })
        .catch(function (error) {
          alert("call_api_call_find_decay" + error);
          // return false;
        });
    },
     // step6
    call_api_call_save_channel_decay() {
        //alert('call-4');
      apifactory
        .call_save_channel_decay()
        .then((res) => {
          if (res != null) {
            let templistnew = [];
            templistnew = res.data;
            this.listfind_decay_output = templistnew;
            if (res.data.status == "402") {
              this.isdecayalreaysave = 1;
              this.savefordb();
            }
            else{
             this.$router.push("/sessionalitysetting");
            }
            

            ////alert(JSON.stringify(res.data));
          }
        })
        .catch(function (error) {
          alert("call_api_call_save_channel_decay" + error);
          // return false;
        });
    },
    // step6-innermethod
    savefordb() {
      try {
        this.listsavefordb = [];
        let groupbydata = [];
        let finallistforsaveindb = [];
        let finallistforsaveindb_temp = [];
        //alert(this.listfind_decay_output.length);
        groupbydata = this.groupBy(this.listfind_decay, "region");
        this.listsavefordb = groupbydata;
        for (let element in groupbydata) {
          let obj1 = new Object();
          obj1.region = element;
          let objdataforsave = new Object();

          for (let index = 0; index < groupbydata[element].length; index++) {
            objdataforsave[groupbydata[element][index].variable] =
              groupbydata[element][index].decay;
          }
          obj1.data = objdataforsave;
          finallistforsaveindb.push(objdataforsave);
          finallistforsaveindb_temp.push(obj1);
          /*let url =
            "region=" +
            element +
            "&param=" +
            "[" +
            JSON.stringify(objdataforsave) +
            "]";
          alert(url);*/
          this.save_channel_decay(
            element,
            "[" + JSON.stringify(objdataforsave) + "]"
          );
        }
        this.listsavefordbfinal = finallistforsaveindb_temp;
        /* alert(this.listfind_decay.length);
        let dataforsave = new Object();
        for (let index = 0; index < this.listfind_decay.length; index++) {
          dataforsave[this.listfind_decay[index].variable] =
            this.listfind_decay[index].decay;
         
        }

        this.listsavefordb = dataforsave;*/
        this.$router.push("/sessionalitysetting");
      } catch (error) {
        alert("savefordb" + error);
      }
    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    save_channel_decay(varregion, varparam) {
      //alert('call save_channel_decay from ctrlfind ');
      apifactory
        .callsave_channel_decay_forsave(varregion, varparam)
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            // this.showmsghide=true;
            // this.listfind_decay=res.data;
            //alert( JSON.stringify(res.data));
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
    },
    //end all step6-innermethod

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    countDownTimerIncrease() {
      setTimeout(() => {
        this.countDown += 1;
        this.countDownTimerIncrease();
      }, 1000);
    },
  },
  computed: {
    getcounter() {
      return this.counternumber + 1;
    },
  },
  created() {
    this.countDownTimerIncrease();
  },

  mounted() {
    
    //this.callworkflowsteps();
    this.call_api_checkdata();
    
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
